<template>
	<div style="padding: 16px; box-sizing: border-box;">
		<!-- 顶部操作区 -->
		<div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
			<h3 style="margin: 0;">{{$t('路费.路费登记') }}</h3>
			<div style="display: flex; align-items: center;">
				<el-form :inline="true" size="mini" style="flex: 1">
					<el-form-item :label="$t('maintenancemanagement.carNo')" style="font-size: 12px;">
						<el-input v-model="searchKey" clearable
							:placeholder="$t('maintenancemanagement.inputcarNo')"></el-input>
					</el-form-item>
					<el-form-item>
						<span style="font-size: 12px;">{{$t('time.timeQuery')}}</span>
						<el-date-picker v-model="dateRange" type="daterange" size="mini"
							:range-separator="$t('time.to')" value-format="yyyy-MM-dd"
							:start-placeholder="$t('time.startTimeHolder')" :end-placeholder="$t('time.endTimeHolder')"
							clearable style="width:265px" />
					</el-form-item>
					<el-form-item>
						<el-button style="margin-left: 30px;" type="primary" size="small"
							@click="handleQuery">{{$t('public.query')}}</el-button>
						<el-button type="success" style="margin-left: 20px;" size="small" @click="handleAdd">
							{{$t('路费.新增路费登记')}}
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<!-- 新增/修改弹窗 -->
		<el-dialog :title="$t('路费.路费信息')" :visible.sync="addDialogVisible" width="750px">
			<el-divider></el-divider>
			<div style="font-size: 14px;margin: 20px 20px;font-weight: 500;">
				{{ formData.CostID ? $t('路费.编辑路费信息') : $t('路费.新增路费信息')}}
			</div>

			<el-form label-width="140px" ref="formRef" :model="formData" :rules="formRules">
				<div style="display: flex; align-items: center; justify-content: center; ">
					<div>
						<!-- 车辆（必填） -->
						<el-form-item :label="$t('maintenancemanagement.carNo')" prop="CarNo" style="margin-top: 10px;">
							<el-select style="width: 100%;" filterable v-model="formData.CarNo"
								:placeholder="$t('路费.请选择车牌号')">
								<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5"
									:key="item.nodeValue" :label="item.vehicleName" :value="item.nodeValue">
								</el-option>
							</el-select>
						</el-form-item>

						<!-- 费用类型 -->
						<el-form-item :label="$t('路费.费用类型')" prop="CostType">
							<el-select style="width: 100%;" v-model="formData.CostType" :placeholder="$t('路费.请选择费用类型')">
								<el-option :label="$t('路费.过路费')" :value="$t('路费.过路费')"></el-option>
								<el-option :label="$t('speedlimit.其他')" :value="$t('speedlimit.其他')"></el-option>
							</el-select>
						</el-form-item>
					</div>

					<div style="margin-right: 40px;">
						<!-- 日期（必填） -->
						<el-form-item :label="$t('路费.产生日期')+':' " prop="CostTime">
							<el-date-picker v-model="formData.CostTime" :picker-options="pickerOptions"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
								:placeholder="$t('vehicleInfo.selectusedate')" />
						</el-form-item>
						<el-form-item :label="$t('路费.路费金额')+':'" prop="CostMoney">
							<el-input v-model.number="formData.CostMoney" :placeholder="$t('路费.请输入费用')"></el-input>
						</el-form-item>

					</div>
				</div>

				<div style="margin-right:15px;margin-left: -25px;">
					<el-form-item :label="$t('路费.备注信息')+':'">
						<el-input type="textarea" v-model="formData.desc" :placeholder="$t('路费.请输入备注信息')" maxlength="100"></el-input>
					</el-form-item>

					<el-form-item :label="$t('路费.备注图片')+':'">
						<!-- 图片上传组件 -->
						<el-upload 
						  list-type="picture-card" 
						  :on-preview="handlePictureCardPreview" 
						   :action="uploadAction"
						  :on-remove="handleRemove" 
						  :file-list="formData.images"
						  :on-error="handleUploadError" 
						  :on-success="handleUploadSuccess"  
						  class="small-upload"
						  :headers="uploadHeaders"
						  :data="{ path: 'app' }"
						  :before-upload="beforeUpload" 
						  name="name"
						  :limit="3"  
						  :on-exceed="handleExceed" 
						>
							<i class="el-icon-plus"></i>
						</el-upload>
					<!-- 	<p style="margin-top: 10px; font-size: 12px; color: #666;">
							{{$t('路费.最多上传3张图片')}}
						</p> -->
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" :alt="$t('路费.预览图片')">
						</el-dialog>
					</el-form-item>
				</div>

				<div style="text-align: right;">
					<el-form-item>
						<el-button @click="addDialogVisible = false">{{$t('public.cancel')}}</el-button>
						<el-button type="primary" @click="handleFormSubmit"
							:loading="submitLoading">{{$t('public.save')}}</el-button>
					</el-form-item>
				</div>
			</el-form>
		</el-dialog>
		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%" max-height="500" v-loading="loading">
			<el-table-column align="center" type="index" :label="$t('public.index')" width="80" />
			<el-table-column align="center" prop="CarNo" :label="$t('行程统计.车牌号')" />
			<!-- 日期列仅显示年月日 -->
			<el-table-column align="center" prop="CostTime" :label="$t('路费.产生日期')" :formatter="formatYmdDate" />
			<el-table-column align="center" prop="CostType" :label="$t('路费.费用类型')" :formatter="formatCostType" />
			<el-table-column align="center" prop="CostMoney" :label="$t('路费.路费金额')" />
			<el-table-column align="center" prop="Memo" :label="$t('路费.备注信息')" />
			<el-table-column align="center" prop="RemarkImage" :label="$t('路费.备注图片')" min-width="120">
				<template #default="scope">
					<!-- 处理多图片逻辑 -->
					<div v-if="scope.row.RemarkImage && scope.row.RemarkImage.trim()">
						<div class="image-group">
							<!-- 循环显示所有图片 -->
							<el-image v-for="(path, index) in getImageList(scope.row.RemarkImage)" :key="index"
								:src="getImageUrl(path)" :preview-src-list="getAllImageUrls(scope.row.RemarkImage)"
								style="width: 40px; height: 40px; cursor: pointer; margin-right: 5px;" fit="cover"
								:alt="$t('路费.备注图片')">
								<!-- 图片加载失败时显示 -->
								<template #error>
									<div
										style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f5f5f5;">
										<i class="el-icon-picture-outline" style="color: #ccc;"></i>
									</div>
								</template>
							</el-image>
						</div>
					</div>
				</template>
			</el-table-column>
			<!-- 操作列 -->
			<el-table-column align="center" :label="$t('public.Operation')" width="140">
				<template #default="scope">
					<el-button size="mini" type="primary"
						@click="handleEdit(scope.row)">{{$t('public.edit')}}</el-button>
					<el-button size="mini" type="danger"
						@click="handleDelete(scope.row.CostID)">{{$t('public.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页组件 -->
		<div style="margin-top: 15px; text-align: right;">
			<div style="text-align: right; margin-top:8px" class="pagination" v-show="total>0">
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
					:page-size="pageSize" layout="total, prev, pager, next" :total="total" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import settings from "@/settings";
	 
	export default {
		name: "travelExpenseRegistration",
		data() {
			return {
				loading: false,
				searchKey: "", // 车牌号查询条件
				dateRange: [
					this.moment().subtract(6, 'days').format('YYYY-MM-DD'), // 默认最近一周（今天-6天）
					this.moment().format('YYYY-MM-DD')
				],
				total: 0, // 数据总条数
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页条数
				tableData: [], // 表格数据
				addDialogVisible: false, // 弹窗显示状态
				submitLoading: false, // 提交按钮加载状态
				dialogImageUrl: '', // 图片预览地址
				dialogVisible: false, // 图片预览弹窗状态
				// 表单数据
				formData: {
					images: [] // 初始化图片数组
				},
				// 表单验证规则
				formRules: {
					CarNo: [{
						required: true,
						message: this.$t("路费.请选择车牌号"),
						trigger: 'change'
					}],
					CostTime: [{
						required: true,
						message: this.$t("路费.请选择发生日期"),
						trigger: 'change'
					}],
					CostMoney: [{
							required: true,
							message: this.$t("路费.请输入费用"),
							trigger: 'blur'
						},
						{
							type: 'number',
							message: this.$t("路费.请输入有效的数字"),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (value <= 0) {
									callback(new Error(this.$t("路费.费用金额必须大于0")));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					CostType: [{
						required: true,
						message: this.$t('路费.请选择费用类型'),
						trigger: 'change'
					}]
				},

				// 日期选择器配置
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},

				// 图片上传基础路径
				imageBaseUrl: '/api/upload/',
				 uploadHeaders: {
				      Token: '' // 后续赋值token
				    }
			}
		},

		computed: {
			size() {
				return this.$store.getters.size
			},
			uploadAction() {
			      return settings.baseUrl + 'automatic/v1/uploadFile';
			    },
			...mapState({
				operator: state => state.user.operator, // 操作人员信息
				vehicles: state => state.app.vehicles, // 车辆列表数据
				token: state => state.user.token
			}),
		},

		mounted() {
			this.getTableData(); // 初始化加载表格数据
			this.uploadHeaders.Token = this.token || '';
		},

		methods: {
			// 超过上传数量限制时的回调
			handleExceed(files, fileList) {
				this.$message.warning(`最多只能上传3张图片`);
			},
			
			// 上传成功回调
			handleUploadSuccess(response, file, fileList) {
				if (response.code === "Success" && response.FileName) {
					// 处理后端返回的文件名，去除"longyi/"前缀
					let fileName = response.FileName.replace(/^longyi\//, '');
					// let fileName = response.FileName;
					
					// 更新文件列表，保存后端返回的文件名
					this.formData.images = fileList.map(item => ({
						...item,
						name: fileName,  // 保存后端返回的文件名
						url: this.getImageUrl(fileName)  // 构建图片预览地址
					}));
					
					// this.$message.success(this.$t('路费.图片上传成功'));
				} else {
					this.$message.error(response.message || this.$t('路费.图片上传失败'));
				}
			},
			
			beforeUpload(file) {
			    console.log("选择的图片原始文件名：", file.name);
			    console.log("图片格式：", file.type);
			    console.log("图片大小：", file.size + " bytes");
			    
			    // 检查图片格式
			    const isImage = file.type.startsWith('image/');
			    if (!isImage) {
			      this.$message.error('只能上传图片文件！');
			      return false;
			    }
			    
			    // 检查图片大小（限制5MB以内）
			    const isLt5M = file.size / 1024 / 1024 < 5;
			    if (!isLt5M) {
			      this.$message.error('图片大小不能超过5MB！');
			      return false;
			    }
			    
			    return true;
			},
			
			formatCostType(row, column, cellValue) {
				// 根据CostType的值返回对应文本
				switch (cellValue) {
					case 1:
						return this.$t('路费.过路费');
					case 2:
						return this.$t('speedlimit.其他');
					default:
						return ''; // 其他情况显示空或"未知"
				}
			},
			
			// 日期格式化函数：仅保留年月日
			formatYmdDate(row, column) {
				const travelTime = row.CostTime;
				if (!travelTime) return '';
				// 处理ISO格式(T分隔)和常规格式(空格分隔)
				return travelTime.split('T')[0].split(' ')[0];
			},

			// 新增按钮点击事件
			handleAdd() {
				this.addDialogVisible = true;
				this.$nextTick(() => {
					this.resetForm();
				});
			},

			// 重置表单
			resetForm() {
				this.formData = {
					CostID: '',
					CarNo: '',
					VID: '',
					CostTime: '',
					CostMoney: '',
					CostType: '',
					desc: '',
					images: []  // 清空图片数组
				};
				if (this.$refs.formRef) {
					this.$refs.formRef.resetFields();
				}
				this.dialogImageUrl = '';
				this.dialogVisible = false;
			},

			// 修改按钮点击事件
			handleEdit(row) {
				console.log(row)
				// 处理图片回显：拼接正式URL
				const images = row.RemarkImage ?
					row.RemarkImage.split(',').map(fileName => ({
						url: this.getImageUrl(fileName),
						name: fileName
					})) : [];
				
				// 查找车辆ID
				let newvehicle = this.vehicles.data.filter((item) => item.treeLevel == 5);
				newvehicle.forEach(item => {
					if (item.vehicleName == row.CarNo) {
						row.VID = item.nodeValue;
					}
				});

				// 填充表单数据
				this.formData = {
					CostID: row.CostID,
					CarNo: row.CarNo,
					VID: row.VID,
					CostTime: this.formatYmdDate(row, null),
					CostMoney: row.CostMoney,
					CostType: row.CostType == 1 ? this.$t('路费.过路费') : this.$t('speedlimit.其他'),
					desc: row.Memo || '',
					images: images  // 回显图片
				};
				this.addDialogVisible = true;
			},

			// 删除按钮点击事件
			handleDelete(CostID) {
				this.$confirm(this.$t('路费.确定要删除这条记录吗'), this.$t('public.tips'), {
					type: 'warning'
				}).then(() => {
					this.$api.saveCostInfoNew({
						operate: 3, // 3表示删除
						CostID: CostID
					}).then(res => {
						if (res.code === 200) {
							this.$message.success(this.$t('public.hasDeleted'));
							this.getTableData();
						} else {
							this.$message.error(this.$t('public.DeleteFail') + ':' + (res.message || ''));
						}
					}).catch(err => {
						this.$message.error(this.$t('路费.接口请求失败'));
						console.error(err);
					});
				});
			},

			// 表单提交处理
			handleFormSubmit() {
				this.$refs.formRef.validate(async (valid) => {
					if (!valid) {
						this.$message.warning(this.$t('路费.表单填写有误'));
						return;
					}
					try {
						this.submitLoading = true;
						const isEdit = !!this.formData.CostID;

						// 处理图片数据：提取后端返回的文件名数组
						const remarkImages = this.formData.images
							.filter(img => img && img.name && typeof img.name === 'string')
							.map(img => img.name);  // 使用后端返回的文件名

						// 验证核心数据
						if (!this.formData.CarNo) throw new Error(this.$t('recharge.请选择车辆'));
						if (!this.formData.CostTime) throw new Error(this.$t('vehicleInfo.selectusedate'));
						if (this.formData.CostMoney === '' || this.formData.CostMoney <= 0) throw new Error(
							this.$t('路费.请输入有效的费用'));
						
						// 查找车辆ID
						let newvehicle = this.vehicles.data.filter((item) => item.treeLevel == 5);
						newvehicle.forEach(item => {
							if (item.vehicleName == this.formData.CarNo) {
								this.formData.CarNo = item.nodeValue;
							}
						});
						
						const params = {
							CostID: this.formData.CostID || 0,
							V_ID: this.formData.CarNo,
							CostTime: this.formData.CostTime,
							CostType: this.formData.CostType == this.$t('路费.过路费') ? 1 : 2,
							CostMoney: this.multiplyBy100(this.formData.CostMoney).toString(),
							Dealer: "",
							EntryName: this.operator.OpeName,
							EntryTime: this.formData.CostTime,
							Memo: this.formData.desc,
							RemarkImage: remarkImages.join(','),  // 将图片数组转为逗号分隔的字符串
							operate: isEdit ? 2 : 1, // 1新增 2修改
						};

						const res = await this.$api.saveCostInfoNew(params);

						if (res.code === 200) {
							this.$message.success(isEdit ? this.$t('public.edit_success') : this.$t(
							'路费.新增成功'));
							this.addDialogVisible = false;
							this.getTableData();
						} else {
							throw new Error(res.message || (isEdit ? this.$t('changepsw.change_fail') : this
								.$t('路费.新增失败')));
						}
					} catch (err) {
						console.error(this.$t('路费.表单提交失败'), err);
						this.$message.error(this.$t('路费.操作失败') + ':' + err.message);
					} finally {
						this.submitLoading = false;
					}
				});
			},

			// 处理数字乘以100，避免浮点数问题
			multiplyBy100(value) {
				const num = value === '' || value === null ? 0 : Number(value);
				if (isNaN(num)) return 0;
				return Math.round(num * 100 * 100) / 100;
			},

			// 图片预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},

			// 将逗号分隔的图片路径字符串转为数组
			getImageList(remarkImageStr) {
				if (!remarkImageStr || typeof remarkImageStr !== 'string') {
					return [];
				}
				return remarkImageStr.split(',').filter(path => path.trim());
			},

			// 生成所有图片的完整URL（用于预览）
			getAllImageUrls(remarkImageStr) {
				const imageList = this.getImageList(remarkImageStr);
				return imageList.map(path => this.getImageUrl(path));
			},

			// 移除图片
			handleRemove(file, fileList) {
				this.formData.images = fileList;
			},

			// 上传失败回调
			handleUploadError(err, file, fileList) {
				this.formData.images = fileList.filter(item => item.uid !== file.uid);
				this.$message.error(this.$t('路费.图片上传失败'));
			},

			// 获取图片正式URL
			getImageUrl(fileName) {
				if (!fileName) return '';
				// 如果文件名已经包含完整路径，则直接使用，否则拼接baseUrl
				return fileName.startsWith('http') ? fileName : settings.baseUrl + fileName;
			},

			// 查询按钮点击事件
			handleQuery() {
				this.currentPage = 1;
				this.getTableData();
			},

			// 分页页码变更
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getTableData();
			},

			// 获取表格数据
			getTableData() {
				this.loading = true;
				const beginDate = this.dateRange[0] || '';
				const endDate = this.dateRange[1] || '';

				this.$api.queryCostInfoNew({
					CarNo: this.searchKey,
					BeginDate: beginDate,
					EndDate: endDate,
					PageNo: this.currentPage,
					PageSize: this.pageSize,
				}).then(res => {
					this.loading = false;
					if (res.code === 200) {
						this.tableData = res.data || [];
						this.total = res.count || 0;
					} else {
						this.tableData = [];
						this.total = 0;
						this.$message.error(this.$t('路费.数据加载失败') + ':' + (res.message || ''));
					}
				}).catch(err => {
					this.loading = false;
					this.$message.error(this.$t('路费.接口请求失败'));
					console.error(err);
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-form-item__label {
			font-size: 12px;
		}

		.el-input__inner {
			width: 220px !important;
		}

		// 操作按钮样式优化
		.el-button--mini {
			padding: 4px 8px;
		}

		// 缩小上传组件尺寸
		.small-upload {
			.el-upload--picture-card {
				width: 80px !important;
				height: 80px !important;
				line-height: 80px !important;
			}

			// 缩小上传按钮图标
			.el-icon-plus {
				font-size: 20px !important;
			}

			// 缩小已上传图片的尺寸
			.el-upload-list__item {
				width: 80px !important;
				height: 80px !important;
			}
		}

		// 表格图片预览样式
		.el-image {
			border-radius: 4px;
		}
	}

	/* 图片组样式：横向排列 */
	.image-group {
		display: inline-flex;
		align-items: center;
		flex-wrap: nowrap;
		max-width: 100%;
		overflow: hidden;
	}

	/* 确保表格单元格内容不换行 */
	::v-deep .el-table .cell {
		white-space: nowrap;
	}
</style>